/**
 * Показываем ошибки из виджета коллтача для полей формы
 * @param {HTMLFormElement} form
 * @param {array} errors
 *
 * Ошибки приходят в формате массива объектов:
 * {
 *     fieldPath: "имя поля",
 *     message: "ошибка",
 * }
 */
export const formCalltouchWidgetErrors = (form, errors) => {
    form.querySelectorAll('.form-group').forEach(function (formGroup) {
        formGroup.classList.remove('has-error');
        errors.forEach(function (error) {
            if (formGroup.querySelector(`[name="${error.fieldPath}"]`)) {
                formGroup.classList.add('has-error');
                let helpBlock = formGroup.querySelector('.help-block');
                if (helpBlock && typeof error.message !== 'undefined') {
                    helpBlock.innerText = error.message;
                }
            }
        });
    });
};

export default formCalltouchWidgetErrors;
